import { Route } from "react-router-dom";
import ClientUserList from "../components/index";

import ClientMiddleware from "../../client-middleware/components";

const ClientUserListiRoutes = () => (
  <>
    <Route path="/user-list" element={<ClientMiddleware><ClientUserList /></ClientMiddleware>} />
  </>
);


export default ClientUserListiRoutes;